import TemplateHeader from "components/Header";
import LoadingOverlay from "components/Indicator/LoadingOverlay";
import TemplateSidemenu from "components/Menu/Sidemenu";
import CustomModal from "components/Modal";
import Pagination from "components/Pagination";
import CustomTable from "components/Table";
import TemplateContainerMain from "components/Template";
import PageTitle from "components/Title/PageTitle";
import moment from "moment";
import { Component } from "react";
import _ from "lodash";
import { RolesPermission } from "Config";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Card, CardBody, Col, Row } from "reactstrap";
import { compose } from "redux";
import FilterForm from "./Form";
import ReportAPI from "./action.js";
import { CheckUserRolesPermissons } from "actions/roles";

class RevenueReportToSCCPNY extends Component {
	state = {
		filterQuery: "",
	};

	componentDidMount = () => {
		let tempModule = _.find(RolesPermission, {
			moduleID: CheckUserRolesPermissons(this.props.data.ProfileReducer.profile.roles).id,
		});

		if (tempModule && !tempModule.permissions.includes(13)) {
			return this.props.history.push("/");
		}
		this.props.getReport();
	};

	componentDidUpdate = (pp) => {
		const { reportPages, getReport } = this.props;
		const { filterQuery } = this.state;
		if (pp.reportPages !== reportPages) {
			getReport(`${!!filterQuery ? filterQuery : ""}`);
		}
	};

	renderReportTable = () => {
		const { reportList, onLoad } = this.props;
		return (
			<CustomTable
				data={reportList}
				showPagination={false}
				loading={onLoad}
				columnsContent={[
					{
						Header: "Invoice Date",
						accessorKey: "invoice_date",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return (
								<>
									{val.invoice_date
										? moment(val.invoice_date, "YYYY-MM-DD HH:mm:ss").format(
												"DD/MM/YYYY hh:mm A"
										  )
										: ""}
								</>
							);
						},
					},
					{
						Header: "Invoice Number",
						accessorKey: "invoice_no",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_no}</>;
						},
					},
					{
						Header: "Agent ID",
						accessorKey: "agent_id",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val?.agent_id}</>;
						},
					},
					{
						Header: "Agent Name",
						accessorKey: "agent_name",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val?.agent_name}</>;
						},
					},
					{
						Header: "Plan",
						accessorKey: "plan_name",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val?.plan_name}</>;
						},
					},
					{
						Header: "Order Description",
						accessorKey: "order_description",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.order_description}</>;
						},
					},
					{
						Header: "Order Add -Ons",
						accessorKey: "order_add_ons",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.order_add_ons}</>;
						},
					},
					{
						Header: "Invoice Amount",
						accessorKey: "invoice_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_amount}</>;
						},
					},
					{
						Header: "SinChew",
						accessorKey: "sin_chew",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.sin_chew}</>;
						},
					},
					{
						Header: "NanYang",
						accessorKey: "nan_yang",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.nan_yang}</>;
						},
					},
					{
						Header: "ChinaPress",
						accessorKey: "china_press",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.china_press}</>;
						},
					},
				]}
			/>
		);
	};

	renderFilterModal = () => {
		const { getReport, onChangeHOC, showFilterModal } = this.props;

		const customSetState = (newState) => {
			this.setState(newState);
		};

        const handleSubmit = (filterQuery) => {
            getReport(filterQuery);
            onChangeHOC("filterQuery", filterQuery);
        }

		return (
			<CustomModal
				size={"lg"}
				title="Revenue Report to SC/CP/NY Filter"
				isOpen={showFilterModal}
				onClose={() => onChangeHOC("showFilterModal", false)}>
				<FilterForm
					onSubmit={handleSubmit}
					onChangeHOC={onChangeHOC}
					handleState={customSetState}
				/>
			</CustomModal>
		);
	};

	render = () => {
		const { onChangeHOC, reportPages, reportCount } = this.props;

		return (
			<>
				<TemplateContainerMain>
					<TemplateHeader
						onClickToggleProfileModal={() => {}}
						history={this.props.history}
						user={this.props.data.ProfileReducer.profile}
					/>
					<div className="app-main">
						<TemplateSidemenu
							userPermissions={this.props.userPermissions}
							user={this.props.user}
							userRole={this.props.userRole}
						/>
						<div className="app-main__outer">
							<div className="app-main__inner">
								<>
									<PageTitle
										heading="Revenue Report to SC / CP / NY"
										buttons={[
											{
												color: "",
												className: "btn-outline-primary mr-2",
												onClick: () => { this.props.exportReport() },
												content: (
													<>
														<span>Export</span>
													</>
												),
											},
											{
												color: "",
												className: "btn-outline-primary",
												onClick: () => onChangeHOC("showFilterModal", true),
												content: (
													<>
														<span>Filter</span>
													</>
												),
											},
										]}
									/>
									<ReactCSSTransitionGroup
										component="div"
										transitionName="TabsAnimation"
										transitionAppear={true}
										transitionAppearTimeout={0}
										transitionEnter={false}
										transitionLeave={false}>
										<Row>
											<Col md={12} style={{minWidth: 'max-content'}}>
												<Card className="main-card mb-3">
													<CardBody>
														{this.renderReportTable()}
														<Pagination
															pageIndex={reportPages}
															totalCount={reportCount}
															onChangePage={(val) =>
																onChangeHOC("reportPages", val)
															}
														/>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</ReactCSSTransitionGroup>
									{this.renderFilterModal()}
									{this.props.onLoad && <LoadingOverlay />}
								</>
							</div>
						</div>
					</div>
				</TemplateContainerMain>
			</>
		);
	};
}

export default compose(ReportAPI)(RevenueReportToSCCPNY);
